import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRolesApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getRolesListApi = createAsyncThunk('getRolesList', async (payload) => {
  return await getRolesApi(payload);
});

const getRolesListSlice = createSlice({
  name: 'getRolesList', // Unique Name
  initialState,
  reducers: {
    getRolesListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRolesListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getRolesListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getRolesListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getRolesListReset } = getRolesListSlice.actions;

export default getRolesListSlice.reducer;
